export default class Layout {

  constructor(id, startDate, endDate, mappedAreaId) {
    this.id = id;
    this.startDate = startDate;
    this.endDate = endDate;
    this.mappedAreaId = mappedAreaId;
  }

  static fromAttributes({ id, start_date, end_date, mapped_area_id }) {
    return new Layout(
      id,
      start_date,
      end_date,
      mapped_area_id,
    );
  }

}
